<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">总账</span>
    </div>
    <div class="margin-right-left margin-top">
      <account-period-selector
          @confirm="handleConfirm"
          @date-change="handleDateChange"
          :current-subject="subject"
          :subject-list="subjectList"
      />
      <div class="float-right">
        <Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
      </div>
    </div>
    <div class="h-panel-body margin" :space-x="10" style="overflow-x: auto;padding: 0;">
      <Loading text="总账数据加载中..." :loading="loading"></Loading>

      <!-- 非数量金额表格：绝对定位方案，彻底解决对齐 -->
      <div v-if="!showNumPrice" class="table-container">
        <!-- 核心：外层容器相对定位，内部表头和内容重叠 -->
        <div class="table-wrap">
          <!-- 固定表头：绝对定位，宽度100% -->
          <table class="summary table-header">
            <thead>
            <tr class="header bg-primary-color white-color">
              <td width="100">科目编码</td>
              <td width="200">科目名称</td>
              <td width="100">期间</td>
              <td width="150">摘要</td>
              <td width="120">借方金额</td>
              <td width="120">贷方金额</td>
              <td width="80">方向</td>
              <td width="120">余额</td>
            </tr>
            </thead>
          </table>
          <!-- 滚动内容：padding-top预留表头高度，宽度100% -->
          <div class="table-body">
            <table class="summary table-content">
              <tbody>
              <template v-for="item in datalist">
                <tr class="bg-gray3-color" :key="`item-${item.id}`">
                  <td colspan="8">
                      <span @click="toggleSummary(item)" class="text-hover">
                        <i class="fa fa-caret-down" :class="{'fa-caret-right':item._expand}"></i>
                        <span class="primary-color font-bold"> {{item.name}}</span>
                      </span>
                  </td>
                </tr>
                <template v-if="!item._expand" v-for="s in item.subjectSummary">
                  <!--                  <tr class="summary-row" :key="`summary-${s.id || item.id + '-' + s.code}`">-->
                  <tr class="summary-row" >
                    <td width="100">{{s.code}}</td>
                    <td width="200">{{s.subjectFullName}}</td>
                    <td width="100">{{s.voucherDate|fqFormat}}</td>
                    <td width="150">{{s.summary}}</td>
                    <td width="120" align="right">{{s.debitAmount}}</td>
                    <td width="120" align="right">{{s.creditAmount}}</td>
                    <td width="80" align="center">{{s.balanceDirection}}</td>
                    <td width="120" align="right">{{s.balance}}</td>
                  </tr>
                </template>
              </template>
              <tr v-if="!datalist.length">
                <td colspan="8" class="text-center padding">暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 数量金额表格：同样用绝对定位方案 -->
      <!--      <div v-else class="table-container">
              <div class="table-wrap" style="width: 1780px;">
                &lt;!&ndash; 固定表头 &ndash;&gt;
                <table class="cus-table table-header">
                  <thead class="header">
                  <tr>
                    <td rowspan="2" width="100">科目编码</td>
                    <td rowspan="2" width="100">科目名称</td>
                    <td rowspan="2" width="80">单位</td>
                    <td colspan="4">期初余额</td>
                    <td colspan="2">本期借方</td>
                    <td colspan="2">本期贷方</td>
                    <td colspan="2">本年累计借方</td>
                    <td colspan="2">本年累计贷方</td>
                    <td colspan="4">期末余额</td>
                  </tr>
                  <tr>
                    <td width="100">方向</td>
                    <td width="100">数量</td>
                    <td width="100">单价</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">方向</td>
                    <td width="100">数量</td>
                    <td width="100">单价</td>
                    <td width="100">金额</td>
                  </tr>
                  </thead>
                </table>
                &lt;!&ndash; 滚动内容 &ndash;&gt;
                <div class="table-body">
                  <table class="cus-table table-content">
                    <tbody>
                    <tr v-for="{subject,summary} in datalist" :key="subject.id">
                      <td width="100">{{subject.code}}</td>
                      <td width="100">{{subject.name}}</td>
                      <td width="80" class="text-center">{{subject.unit}}</td>
                      <td width="100" class="text-center">{{summary[0].balanceDirection}}</td>
                      <td width="100" class="text-right">{{summary[0].num}}</td>
                      <td width="100" class="text-right">{{summary[0].price|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[0].balance|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[1].debitAmount ? summary[1].num:''}}</td>
                      <td width="100" class="text-right">{{summary[1].debitAmount|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[1].creditAmount ? summary[1].num:''}}</td>
                      <td width="100" class="text-right">{{summary[1].creditAmount|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[2].debitAmount ? summary[2].num:''}}</td>
                      <td width="100" class="text-right">{{summary[2].debitAmount|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[2].creditAmount ? summary[2].num:''}}</td>
                      <td width="100" class="text-right">{{summary[2].creditAmount|numFormat}}</td>
                      <td width="100" class="text-center">{{summary[1].balanceDirection}}</td>
                      <td width="100" class="text-right">{{summary[1].num}}</td>
                      <td width="100" class="text-right">{{summary[1].price|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[1].balance|numFormat}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>-->
    </div>
  </app-content>
</template>

<script>
export default {
  name: 'GeneralLedger',
  data() {
    return {
      loading: false,
      accountDate: null,
      showNumPrice: false,
      numPriceDisabled: true,
      datalist: [],
      subjectList: [],
      startDate: null,
      endDate: null,
      formattedStartDate: null,
      subject: null,
      subjectId: null,
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'subjectCodeName',
        dataMode: 'list',
        datas: []
      },
    };
  },
  watch: {
    subject() {
      let org = this.showNumPrice;
      if (this.subject.unit) {
        this.numPriceDisabled = false;
        this.showNumPrice = true;
      } else {
        this.showNumPrice = false;
      }
      this.loadList();
    },
    showNumPrice() {},
  },
  created() {
    this.loadSubject();
  },
  methods: {
    formatDateToFirstDay(monthStr) {
      const [year, month] = monthStr.split('-').map(Number);
      const firstDay = new Date(year, month - 1, 1);
      return `${year}-${String(month).padStart(2, '0')}-01`;
    },

    handleDateChange({ startMonth, endMonth }) {
      if (startMonth) {
        this.formattedStartDate = this.formatDateToFirstDay(startMonth);
        const [year, month] = startMonth.split('-').map(Number);
        this.startDate = new Date(year, month - 1, 1);
      }

      if (endMonth) {
        this.formattedEndDate = this.formatDateToFirstDay(endMonth);
        const [year, month] = endMonth.split('-').map(Number);
        this.endDate = new Date(year, month - 1, 1);
      }

      console.log('起始日期（格式化）:', this.formattedStartDate);
      console.log('结束日期（格式化）:', this.formattedEndDate);
    },

    handleConfirm(params) {
      console.log('确认所有参数:', params);
      this.formattedStartDate = this.formatDateToFirstDay(params.startMonth);
      this.formattedEndDate = this.formatDateToFirstDay(params.endMonth);

      // 新增：从params中提取子组件选中的科目，同步更新父组件subject和subjectId
      if (params.subject) {
        // 更新subject（完整科目对象）
        this.subject = params.subject;
        // 同步更新subjectId（关键：解决subjectId不变化的问题）
        this.subjectId = params.subject.id;
      } else {
        // 若子组件清空了科目，重置父组件对应状态
        this.subject = null;
        this.subjectId = null;
      }

      this.loadList();
    },
    loadList() {
      this.loading = true;

      let sId = this.subjectId;
      this.$api.accountbook.loadGeneralLedgerByDate({
        startDate: this.formattedStartDate,
        endDate: this.formattedEndDate,
        subjectId: this.subjectId,
        showNumPrice: this.showNumPrice,
      }).then(({ data }) => {
        this.datalist = data;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    async loadSubject() {
      this.datalist = [];
      try {
        const { data } = await this.$api.accountbook.loadSubject({ accountDate: this.accountDate });
        const formattedData = data.map(subject => ({
          id: subject.id,
          subjectCode: subject.code,
          subjectName: subject.name,
          subjectCodeName: subject.code + " " + subject.name,
          subjectFullName: subject.subjectFullName || subject.name,
          ...subject
        }));
        this.subjectList = formattedData;
        this.$set(this.param, "datas", formattedData);
        if (formattedData.length) {
          this.subjectId = formattedData[0].id;
          this.subject = formattedData[0];
        }
      } catch (error) {
        console.error('加载科目失败:', error);
      }
    },
    toggleSummary(item) {
      this.$set(item, '_expand', !item._expand);
    }
  }
};
</script>

<style scoped lang="less">
/* 核心：绝对定位表格容器样式，仅新增1行height属性，其余完全不变 */
.table-container {
  width: 100%;
  box-sizing: border-box;

  .table-wrap {
    position: relative; /* 原有属性不变 */
    max-height: 650px; /* 原有属性不变，保留你的固定高度 */
    height: 650px; /* 唯一新增：明确固定高度，让滚动生效 */
    overflow: hidden; /* 原有属性不变 */
    border: 1px solid #eee; /* 原有属性不变 */
  }

  /* 固定表头：所有属性完全不变，确保表头不滚动 */

  .table-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 20;
    border-collapse: collapse;
    box-sizing: border-box;
  }

  /* 滚动内容：所有属性完全不变，仅因父元素有明确高度而正常滚动 */

  .table-body {
    width: 100%;
    height: 100%;
    padding-top: 35px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  /* 内容表格：所有属性完全不变 */

  .table-content {
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
  }
}

/* 非数量金额表格样式：完全不变 */
.summary {
  td {
    padding: 0 8px;
    border: 1px solid #eee;
    font-size: 12px;
    height: 32px;
    box-sizing: border-box;
  }

  .summary-row:nth-child(even) {
    background-color: #f8fbf8;
  }

  .summary-row:hover {
    background-color: #dff7df;
  }

  .header {
    td {
      text-align: center;
      font-weight: bold;
      height: 35px; /* 与table-body的padding-top一致，原有属性不变 */
    }
  }

  .bg-gray3-color {
    td {
      border: 1px solid #eee;
      height: 32px;
    }
  }
}

/* 数量金额表格样式：完全不变 */
.cus-table {
  td {
    padding: 0 8px;
    border: 1px solid #eee;
    font-size: 12px;
    height: 32px;
    box-sizing: border-box;
  }

  .header {
    td {
      text-align: center;
      font-weight: bold;
      height: 35px;
      background: #f5f5f5;
    }
  }
}

/* 辅助样式：完全不变 */
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.padding {
  padding: 10px;
}

.text-hover {
  cursor: pointer;
}
</style>